// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## Sale Get
/**
 *
 * @param {{params: object, query: { customerId: string, mrId: string, userId: string, lang: string, saleId: string, search: string, page: number, limit: number  }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.UserLog.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};

export default {
  GetAll,
};
